import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@/assets/css/global.css'
import '@/assets/css/element-icons.css'
import '@/assets/css/theme-ep.css'
import request from "@/utils/request";

const app = createApp(App)

app.config.globalProperties.$request = request
app.config.globalProperties.$baseUrl = process.env.VUE_APP_BASEURL
// 文件下载鉴权（/files 纳入登录校验后）：图片地址自动追加 token 参数
app.config.globalProperties.$fileUrl = function (url) {
  if (!url) return url
  if (url.indexOf('/files/') === -1) return url
  const user = JSON.parse(localStorage.getItem('xm-user') || '{}')
  if (!user.token) return url
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'token=' + encodeURIComponent(user.token)
}

app.use(router)
app.use(ElementPlus, { size: 'small', locale: zhCn })

app.mount('#app')
